// ** React Imports
import {lazy, useEffect} from 'react';

// ** Utils
import {useRouterTransition} from '@hooks/useRouterTransition';
import ScrollToTop from "../utility/ScrollToTop";

// ** Router Components
import {BrowserRouter as AppRouter, Navigate, Route, Routes as Routers} from 'react-router-dom';

// ** Routes & Default Routes
import {LoginRoute, Routes} from './routes'

// ** Layouts
import BlankLayout from '@src/layouts/BlankLayout';
import WebLayout from '@src/layouts/WebLayout';
import VerticalLayout from '@src/layouts/VerticalLayout';
import {useSelector} from "react-redux";
import Ping from "@configs/request/Ping";

const Router = () => {
    // ** All of the available layouts
    const Layouts = {BlankLayout, VerticalLayout, WebLayout}
    const [transition, setTransition] = useRouterTransition()
    const auth = useSelector(state => state.auth);

    // ** Init Error & NotAuthorized Component
    const Error = lazy(() => import('../views/pages/misc/Error'))
    const NotAuthorized = lazy(() => import('../views/pages/misc/NotAuthorized'))

    const LoginComponent = lazy(() => import('@src/views/web/authentication/Login'))

    useEffect(() => {
        Ping();
    }, [])


    return (
        <AppRouter basename={process.env.REACT_APP_BASENAME}>
            <ScrollToTop/>
            <Routers>
                {/* WEB Route */}
                <Route path="/" element={<Layouts.WebLayout/>}>
                    {/* Error & auth */}
                    <Route path='404' element={<Error/>}/>
                    <Route path='401' element={<NotAuthorized/>}/>

                    {Routes.web.map((item, index) => {
                        if (item.auth) {
                            return <Route key={index}
                                          path={item.path}
                                          element={
                                              auth.token ?
                                                  <item.component/> :
                                                  <Navigate to='/401'/>
                                          }/>
                        } else
                            return <Route key={index} path={item.path} element={<item.component/>}/>
                    })}
                </Route>
                {/* Login Route */}
                <Route path="/" element={<Layouts.BlankLayout/>}>
                    <Route
                        path={LoginRoute}
                        element={<LoginComponent/>}
                    />
                </Route>
                {/* Panel Route */}
                <Route path="/panel" element={<Layouts.VerticalLayout transition={transition}/>}>
                    {Routes.panel.map((item, index) => {
                        if (item.auth) {
                            return <Route key={index}
                                          path={item.path}
                                          element={
                                              auth.token ?
                                                  <item.component/> :
                                                  <Navigate to='/401'/>
                                          }/>
                        } else
                            return <Route key={index} path={item.path} element={<item.component/>}/>
                    })}
                </Route>

                {/* NotFound Error page */}
                <Route path='*' element={<Navigate to="/404"/>}/>
            </Routers>
        </AppRouter>
    )
}

export default Router
